/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'logs-signpost-custom-waf-rule';
const prefix = `${moduleName}.${componentName}`;

export const logsNumberLabel = `${prefix}.logsNumberLabel`;
export const logsPercentageLabel = `${prefix}.logsPercentageLabel`;

export const ENGLISH = {
    [logsNumberLabel]: '# Logs',
    [logsPercentageLabel]: '% of Logs',
};
